import { useState } from 'react';
import { Flex, Switch, Text } from '@nula/core-ui';
import shared from '../_shared.module.css';
import styles from './notifications-tab.module.css';

function NotificationRow({
  title,
  description,
  checked,
  onChange,
}: {
  title: string;
  description: string;
  checked: boolean;
  onChange: (v: boolean) => void;
}) {
  return (
    <Flex align="start" justify="space-between" gap="md">
      <Flex vertical gap="xs" className={styles.notificationRowBody}>
        <Text size="sm" className={styles.notificationSectionLabel}>{title}</Text>
        <Text size="xs" type="secondary">{description}</Text>
      </Flex>
      <Switch checked={checked} onChange={onChange} size="sm" />
    </Flex>
  );
}

export function NotificationsTab() {
  const [weekSummary, setWeekSummary] = useState(true);
  const [productUpdates, setProductUpdates] = useState(false);
  const [mentions, setMentions] = useState(true);

  return (
    <Flex vertical gap="lg">
      <Flex vertical gap="xs">
        <Text size="md" className={styles.notificationSectionLabel}>Notifications</Text>
        <Text size="sm" type="secondary">Choose what updates you want to receive.</Text>
      </Flex>

      <Flex vertical gap="sm">
        <Text className={shared.sectionGroupLabel}>Email Notifications</Text>
        <NotificationRow
          title="Weekly Summary"
          description="Get a weekly summary of your thoughts and activities."
          checked={weekSummary}
          onChange={setWeekSummary}
        />
        <NotificationRow
          title="Product Updates"
          description="Receive news about new features and improvements."
          checked={productUpdates}
          onChange={setProductUpdates}
        />
      </Flex>

      <Flex vertical gap="sm" className={styles.notificationSection}>
        <Text className={shared.sectionGroupLabel}>In-App Notifications</Text>
        <NotificationRow
          title="Collaborator Mentions"
          description="Notify me when someone mentions me."
          checked={mentions}
          onChange={setMentions}
        />
      </Flex>
    </Flex>
  );
}
